import AdminLayout from "../../../components/admin/layout/AdminLayout";
import CreateSurveyor from "../../../components/common/surveyor/CreateSurveyor";
import { useLocation } from "react-router-dom";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";

function SurveyorEditPage() {
  const { userType } = useAuthStore();
  const location = useLocation();
  const editData = location.state || {};

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <CreateSurveyor editData={editData} />
    </AdminLayout>
  );
}

export default SurveyorEditPage;
